

const webanalytics = (function () {
  let componentSelectorList = ["button[data-track]"];
  let linkSelectorList = [
    "a.navigation__link",
    "a.header-account-link",
    "a[data-track]",
  ];

  const GA4_MAX_PARAMS = 25;
  const GA4_MAX_VALUE_LENGTH = 100;

  function trackDebug(message) {
    if (JSON.parse(localStorage.getItem("linkTrack")) == true) {
      console.log(message);
    }
  }
  return {
    ga4Params: function (props) {
      const out = {};
      if (!props || typeof props !== "object") return out;
      let count = 0;
      Object.keys(props).forEach(function (key) {
        if (count >= GA4_MAX_PARAMS) return;
        const value = props[key];
        if (value === null || value === undefined) return;
        let clean;
        if (typeof value === "number") {
          if (!isFinite(value)) return;
          clean = value;
        } else if (typeof value === "boolean") {
          clean = value;
        } else if (typeof value === "string") {
          clean = value.slice(0, GA4_MAX_VALUE_LENGTH);
        } else {
          return;
        }
        out[key] = clean;
        count++;
      });
      return out;
    },

    sendGA4: function (event, props) {
      if (typeof window.gtag !== "function") return;
      if (window.Shopify && window.Shopify.designMode) return;
      try {
        window.gtag("event", event, this.ga4Params(props));
      } catch (e) {}
    },

    prepLinkComponentData: function (el) {
      let eventData = {
        text:
          $(el)?.attr("data-track")?.toLowerCase() ||
          $(el)?.text()?.toLowerCase() ||
          "no_text",
        href: $(el)?.attr("href") || "no_link",
        placement:
          $(el).closest("[data-track-section]").attr("data-track-section") ||
          $(el).closest("[data-section-type]")?.attr("data-section-type"),
      };
      return eventData;
    },

    emitEvent: function (type, eventData) {
      if (type === "link_click") {
        localStorage.setItem("linkTrack", JSON.stringify(eventData));
        return;
      }
      if (type === "component_click") {
        this.publishLinkComponentClick(type, eventData);
        return;
      }
      // One transport per event: sending flow_* both ways double-counts in GA4.
      const isFlow =
        type === "flow_start" || type === "flow_step" || type === "flow_complete";
      const busOnly = isFlow && (window.TRP_FLOW_TRANSPORT || "bus") === "bus";

      if (!busOnly) this.sendGA4(type, eventData);
      if (busOnly || !isFlow) {
        if (
          typeof Shopify !== "undefined" &&
          Shopify.analytics &&
          typeof Shopify.analytics.publish === "function"
        ) {
          Shopify.analytics.publish(type, eventData);
        } else {
          console.warn("Shopify analytics not available for event:", type, eventData);
        }
      }
    },

    publishLinkComponentClick: function (type = "link_click", eventData) {
      if (eventData && eventData.text !== "no_text") {
        this.sendGA4(type, eventData);
        if (
          typeof Shopify !== "undefined" &&
          Shopify.analytics &&
          typeof Shopify.analytics.publish === "function"
        ) {
          Shopify.analytics.publish(type, eventData);
          console.log(
            "tracking event [" + type + "] emitted for [" + eventData.text + "]",
            eventData
          );
        } else {
          console.warn("Shopify analytics not available for component_click", eventData);
        }
      }
    },

    trackCartDrawerView: function () {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          cart.href = location.pathname;
          this.emitEvent("cart_drawer_viewed", cart);
        });
    },

    trackQuizAddons: function (el) {
      const addOnProdTitleEl = $(el).find(".content-title-add-on")[0];
      const addOnProdTitle = $(addOnProdTitleEl).text();
      let eventData = {
        text: $(addOnProdTitleEl)?.text() || "no_text",
        placement: "quiz add ons",
      };
      this.emitEvent("component_click", eventData);
    },
    trackFlowStep: function (flowEvent, flowName = "subscription_quiz", flowStepName, additionalData, flowType = "quiz") {
      let data = { name: flowName, type: flowType };
      if (flowEvent === "flow_step") data.step_name = flowStepName;
      if (additionalData) data = { ...data, ...additionalData };
      console.log("trackFlowStep function: " + flowEvent, data);
      this.emitEvent(flowEvent, data);
    },
    init: function () {
      const self = this;
      document.addEventListener("DOMContentLoaded", () => {
        const linkSelectors = linkSelectorList.join(", ");
        const componentSelectors = componentSelectorList.join(", ");
        let waited = 0;
        const WaitForAnalytics = setInterval(() => {
          waited += 100;
          if (
            (typeof Shopify !== "undefined" &&
              Shopify.analytics &&
              typeof Shopify.analytics.publish === "function") ||
            waited >= 5000
          ) {
            clearInterval(WaitForAnalytics);

            const quizName = $(".quiz-section").attr("type");
            if (quizName) self.trackFlowStep("flow_start", quizName);

            let previousLinkDetails = JSON.parse(localStorage.getItem("linkTrack"));
            if (previousLinkDetails) {
              self.publishLinkComponentClick("link_click", previousLinkDetails);
              localStorage.removeItem("linkTrack"); //clearing out link tracking details
            }

            //Binding anchors with navigation tracking
            $(linkSelectors).on("mousedown", function (e) {
              self.emitEvent("link_click", self.prepLinkComponentData(e.target));
            });
            $(componentSelectors).on("mousedown", function (e) {
              self.emitEvent("component_click", self.prepLinkComponentData(e.target));
            });
            $("a.cart-link").on("click", function () {
              self.trackCartDrawerView();
            });
            $("div.product-add-on").on("click", function (e) {
              if ($(e.currentTarget).hasClass("added")) {
                self.trackQuizAddons(e.currentTarget);
              }
            });
            if (
              window.location.search.includes("customer_posted") &&
              window.location.hash.includes("footer_newsletter_signup")
            ) {
              self.emitEvent("form_submit", {
                name: "footer_newsletter_signup",
                type: "newsletter",
              });
            }
          }
        }, 100); // Check every 100ms
      });
    },
  };
})();

webanalytics.init();